// {
//   "region": "us-east-1",
//   "userPool": "us-east-1_4K9BCWKKk",
//   "identityPool": "us-east-1:3374bf96-4a44-4ecd-8428-f29445fed059",
//   "clientId": "3haognn9j3up3co4jnhtvghnv6"
// }

export default {
  cognito: {
    REGION: 'us-east-1',
    USER_POOL_ID: 'us-east-1_4K9BCWKKk',
    APP_CLIENT_ID: '3haognn9j3up3co4jnhtvghnv6',
    IDENTITY_POOL_ID: 'us-east-1:3374bf96-4a44-4ecd-8428-f29445fed059'
  }
}



// WEBPACK FOOTER //
// ./src/config/cognito.js